import React, { useRef } from "react";
import { Card } from "react-bootstrap";
import Chart from "react-apexcharts";
import { GraphCardsHeader } from "@ui";

function DistributedBarChart({
  title,
  series,
  labels,
  showYAxis = true,
  exportCSVHeading = "Date,",
  graphColor = [],
  tooltip = "",
}) {
  const chartRef = useRef(null);

  async function downloadPNG() {
    const chartInstance = chartRef.current;
    const base64 = await chartInstance.chart.dataURI();
    const downloadLink = document.createElement("a");
    downloadLink.href = base64.imgURI;
    downloadLink.download = "image.png";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }

  function exportCSV() {
    let csvContent =
      exportCSVHeading + series.map((s) => s.name).join(",") + "\n";
    labels.forEach((category, index) => {
      let row = [category];
      series.forEach((series) => {
        row.push(series.data[index]);
      });
      csvContent += row.join(",") + "\n";
    });
    var blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    var link = document.createElement("a");
    if (link.download !== undefined) {
      var url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", "chart_data.csv");
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  function downloadChart() {
    const chartInstance = chartRef.current;
    if (chartInstance) {
      downloadPNG(chartInstance);
    } else {
      console.error(`Chart not found.`);
    }
  }

  const chartOption = {
    series: series || [],
    options: {
      chart: {
        type: "bar",
        height: 380,
        toolbar: {
          show: false,
        },
      },
      colors: graphColor || [],
      dataLabels: {
        enabled: false,
      },
      plotOptions: {
        bar: {
          columnWidth: "45%",
          distributed: true,
        },
      },
      states: {
        normal: {
          filter: {
            type: "none",
          },
        },
        hover: {
          filter: {
            type: "darken",
            value: 0.8,
          },
        },
      },
      stroke: {
        width: 0,
        curve: "smooth",
      },
      markers: {
        size: [4, 7],
      },
      legend: {
        show: false,
      },
      xaxis: {
        categories: labels || [],
        tickAmount: 5,
        labels: {
          show: true,
          rotateAlways: false,
          hideOverlappingLabels: true,
          showDuplicates: false,
          trim: false,
          formatter: function (value) {
            if (!value || !value.length) return value;
            return value?.replace(/([0-9]+)\s(\w+)/, (match, day, month) => {
              return `${day} ${month?.charAt(0)?.toUpperCase()}${month?.slice(
                1
              )}`;
            });
          },
        },
      },
      yaxis: {
        labels: {
          show: showYAxis,
          formatter: function (value) {
            return Math.round(value);
          },
        },
      },
    },
  };

  return (
    <Card className="flex-grow-1">
      <GraphCardsHeader
        title={title}
        tooltip={tooltip}
        showDownloadButtons={true}
        needImageDownload={true}
        needCSVDownload={true}
        downloadCSV={exportCSV}
        downloadImage={downloadChart}
      />
      <Card.Body className="flex-grow-1">
        <div id="chart-basic-column-bar">
          <Chart
            ref={chartRef}
            options={chartOption.options}
            series={chartOption.series}
            type="bar"
            height={300}
          />
        </div>
      </Card.Body>
    </Card>
  );
}

export default DistributedBarChart;
